import axios from 'axios';
import AxiosInstance from '../config/AxiosInstance';
import config from '../config';
import AxiosInstanceFormData from '../config/AxiosInstanceFormData';

interface saleDetailsPayload {
    salesId: string,
    sequenceNo: number,
    recordType: number,
    articleId?: string,
    itemName: string,
    quantity: number,
    price: number,
    discount?: number,
    net?: number,
    tax?: number,
    amount?: number,
    cost?: number,
    taxId?: string,
    productPriceId: string,
    note?: string,
    isActive?: boolean,
    isDeleted?: boolean,
    createdBy: string,
    updatedAt?: Date,
}

interface SalesPayload {
    clientId: string,
    salesType: string,
    reference: string,
    issuedOn: Date,
    dueDate: Date,
    companyId: string,
    locationId: string,
    quantity: number,
    price: number,
    tax: number,
    discount: number,
    note: string,
    termId: string,
    statusId: string,
    createdBy: string,
    invoiceNumber: string,
    updatedBy: string,
    updatedAt: Date,
    createdAt: Date,
    saleDetails: saleDetailsPayload[]
}


const createPurchases = async (payload: any) => {
    try {
        const { data } = await AxiosInstanceFormData.post('/api/finex/purchases', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getPurchases = async (page: any, limit: any, searchValue: any, companyId: any, tab: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/purchases', {
            params: {
                page: page,
                limit: limit,
                searchValue: searchValue,
                companyId: companyId,
                type: tab
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

const checkInvoiceNumber = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/finex/purchases/checkInvoiceNumber', payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const getTransactionMonth = async (locationId: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/transaction-month', {
            params: {
                company_id: companyId,
                location_id: locationId
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};

const getAssetsCategory = async () => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/purchases/asset-category/list');
        return { data };
    } catch (error) {
        throw error;
    }
};

const getDetailPurchases = async (payload: string) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/purchases/' + payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const updatePurchases = async (id: string, payload: any) => {
    try {
        const { data } = await AxiosInstanceFormData.put('/api/finex/purchases/' + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
};

const deletePurchases = async (id: string) => {
    try {
        const { data } = await AxiosInstance.delete('/api/finex/purchases/' + id);
        return { data };
    } catch (error) {
        throw error;
    }
};
const createPurchasesPayment = async (payload: any) => {
    try {
        const { data } = await AxiosInstance.post('/api/finex/purchases/purchase-Payments', payload);
        return { data };
    } catch (error) {
        throw error;
    }
}

const updateStatusPurchases = async (id: string, payload: any) => {
    // type: any, 
    try {
        const { data } = await AxiosInstance.put('/api/purchases/updateStatus/' + id, payload);
        // const { data } = await AxiosInstance.put('/api/finex/sales/' + type + "/" + id, payload);
        return { data };
    } catch (error) {
        throw error;
    }
};


export {
    createPurchases,
    getPurchases,
    deletePurchases,
    getDetailPurchases,
    updatePurchases,
    createPurchasesPayment,
    updateStatusPurchases,
    getTransactionMonth,
    getAssetsCategory,
    checkInvoiceNumber
}